import React from 'react';

import { Persik } from 'src/components/persik';

export const PersikPage: React.FC = () => {
  return <Persik />;
};
